/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_How_4_AInputs */

const en_mk_how_4_a = /** @type {(inputs: Mk_How_4_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review previews and readiness for automatic projects`)
};

const id_mk_how_4_a = /** @type {(inputs: Mk_How_4_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tinjau pratinjau dan kesiapan proyek otomatis`)
};

/**
* | output |
* | --- |
* | "Review previews and readiness for automatic projects" |
*
* @param {Mk_How_4_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_how_4_a = /** @type {((inputs?: Mk_How_4_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_How_4_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_how_4_a(inputs)
	return en_mk_how_4_a(inputs)
});